import { render, staticRenderFns } from "./entranceShop.vue?vue&type=template&id=59b7b2e6&scoped=true&"
import script from "./entranceShop.vue?vue&type=script&lang=js&"
export * from "./entranceShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b7b2e6",
  null
  
)

export default component.exports